const STORAGE_KEY = 'tasks';

export const getTasks = () => {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
};

export const saveTasks = (tasks) => {
    localStorage.setItem(STORAGE_KEY,JSON.stringify(tasks));
};